import { AccessoriesIcon } from 'components/ProductSidebar/ProductGroupNav/ProductGroupNavSVGs';
import { ProductGroup } from 'rangeConfig/@types';
import selectedMenu from './selectedMenu';
import mainMenu from './mainMenu';
import { ProductType } from '@inter-ikea-storageone/range';

const accessories = (): ProductGroup => {
  return {
    id: 'accessories',
    productTypes: [
      ProductType.PAX_DRAWER_BOX_ASM,
      ProductType.PAX_DRAWER_MAT,
      ProductType.PAX_SKUBB_STORAGE_CASES,
      ProductType.PAX_SKUBB_SHOE_BOXES,
      ProductType.PAX_HEMMAFIXARE_STORAGE_CASE,
      ProductType.PAX_HEMMAFIXARE_STORAGE_CASE_HIGH,
      ProductType.PAX_SKUBB_STORAGE_BOXES,
      ProductType.PAX_HEMMAFIXARE_SHOE_BOX,
      ProductType.PAX_SKUBB_HANGING_STORAGE,
      ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP,
      ProductType.PAX_SKUBB_STORAGE_CASE_WRAP,
      ProductType.PAX_SHOE_MAT
    ],
    icon: AccessoriesIcon,
    mainMenu,
    selectedMenu
  };
};

export default accessories;
